import classnames from 'classnames';
import { Children, type FC, type ReactNode } from 'react';

import styles from 'molecules/TwoColumnGrid/two-column-grid.module.scss';

interface TwoColumnGridProps {
  width: 'narrow' | 'wide';
  children: ReactNode[];
  classes?: {
    container: string;
    gridContainer: string;
    gridItem: string;
  };
}

const TwoColumnGrid: FC<TwoColumnGridProps> = ({ width, children, classes }) => {
  const gridClass = classnames(styles.grid, {
    [classes?.gridContainer || '']: classes?.gridContainer,
    [styles.twoColumn]: true,
  });

  const containerClass = classnames(styles.container, {
    [classes?.container || '']: classes?.container,
    [styles.narrow]: width === 'narrow',
  });

  return (
    <section className={containerClass}>
      <div className={gridClass}>
        {Array.isArray(children) &&
          children.length > 0 &&
          Children.map(children, child => (
            <div
              className={classnames(styles.gridItem, {
                [classes?.gridItem || '']: classes?.gridItem,
              })}
            >
              {child}
            </div>
          ))}
      </div>
    </section>
  );
};

export default TwoColumnGrid;
